import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { IFormTemplate } from '@dataTypes/forms.type'
import {
  fetchFormTemplates,
  fetchFormTemplateById,
} from '../actions/forms.action'

export interface FormsState {
  items: IFormTemplate[]
  itemsLoading: boolean
  itemsError: string | null
  current: IFormTemplate | null
  currentLoading: boolean
  currentError: string | null
}

const initialState: FormsState = {
  items: [],
  itemsLoading: false,
  itemsError: null,
  current: null,
  currentLoading: false,
  currentError: null,
}

const formsSlice = createSlice({
  name: 'forms',
  initialState,
  reducers: {
    clearCurrentFormTemplate(state: FormsState): void {
      state.current = null
      state.currentError = null
      state.currentLoading = false
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchFormTemplates.pending, (state) => {
      state.itemsLoading = true
      state.itemsError = null
    })
    builder.addCase(
      fetchFormTemplates.fulfilled,
      (state, action: PayloadAction<IFormTemplate[]>) => {
        state.items = action.payload
        state.itemsLoading = false
      },
    )
    builder.addCase(fetchFormTemplates.rejected, (state, action) => {
      state.itemsLoading = false
      state.itemsError = action.error.message ?? 'Failed to load form templates'
    })

    builder.addCase(fetchFormTemplateById.pending, (state) => {
      state.currentLoading = true
      state.currentError = null
    })
    builder.addCase(
      fetchFormTemplateById.fulfilled,
      (state, action: PayloadAction<IFormTemplate | null>) => {
        state.current = action.payload
        state.currentLoading = false
      },
    )
    builder.addCase(fetchFormTemplateById.rejected, (state, action) => {
      state.currentLoading = false
      state.currentError =
        action.error.message ?? 'Failed to load form template by id'
    })
  },
})

export const { clearCurrentFormTemplate } = formsSlice.actions

export default formsSlice.reducer
